export default __webpack_public_path__ + "static/media/steps__slider-img-2.4192716e.png";